import { camelCase } from 'lodash';

const requireModule = require.context('.', false, /\.js$/);
const modules = {};

requireModule.keys().forEach((file) => {
  if (file === './index.js') {
    return;
  }

  const moduleConfig = requireModule(file);
  const moduleName = camelCase(file.replace(/\.\/|\.js/g, ''));

  modules[moduleName] = moduleConfig.default || moduleConfig;
});

export default modules;
